// extracted by mini-css-extract-plugin
module.exports = {"header":"header-1AxHn","backBatton":"backBatton-bFAYj","title":"title-2f2lc"};